import React from 'react';
import { getModuleRegistry } from '@wix/cashier-common/dist/src/rmc-fork/ModuleRegistry';
import { IInternalCashierPaymentsProps } from '../../../cashier-payments';
import { WIDGET_ID } from '../../../lazy/config';

export const registerWidgetInRMC = (
  WidgetComponent: React.FC<IInternalCashierPaymentsProps>
) => {
  getModuleRegistry().registerComponent(WIDGET_ID, () => WidgetComponent);
};
